import React from "react";
import _ from "lodash";
import { Grid, TextField, FormHelperText } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import SectionHeader from "./SectionHeader";
import ConfigItemSelect from "./ConfigItemSelect";

const styles = theme => ({
  msaControl: {
    minWidth: 240,
    width: "100%",
    marginTop: "10px"
  },
  stateControl: {
    minWidth: 120,
    marginTop: "10px",
    width: "100%"
  },
  regionControl: {
    minWidth: 120,
    marginTop: "10px",
    width: "100%"
  },
  labelRoot: {
    fontSize: "17px"
  },
  inputField: {
    borderBottom: "1px solid #2196F3"

  },
  error: {
    "& input": {
      borderBottom: "1px solid red"
    }
  }
});

class LocationInfo extends React.Component {
  render() {
    const { handleChange, handleBlur, values, errors, touched } = this.props; // formik props
    const { msaOptions, stateOptions, regionOptions, classes } = this.props;

    return (
      <div>
        <SectionHeader>Location</SectionHeader>
        <Grid container direction="row" spacing={16}>
          <Grid item xs={6}>
            <ConfigItemSelect
              values={values}
              handleChange={handleChange}
              id="msaDropdown"
              label="Metropolitan Statistical Area"
              options={msaOptions}
              fieldName="metropolitanStatisticalAreaId"
              rootClassName={classes.msaControl}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              InputProps={{
                classes: {
                  input: classes.inputField,
                  error: classes.error
                },
                disableUnderline: true
              }}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}
              fullWidth
              required
              error={Boolean(errors.address) && touched.address}
              id="address"
              label="Street Address"
              value={values.address}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.address && <FormHelperText>{errors.address}</FormHelperText>}
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={16}>
          <Grid item xs={6}>
            <TextField
              InputProps={{
                classes: {
                  input: classes.inputField,
                  error: classes.error
                },
                disableUnderline: true
              }}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}
              fullWidth
              required
              error={Boolean(errors.city) && touched.city}
              id="city"
              label="City"
              value={values.city}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.city && <FormHelperText>{errors.city}</FormHelperText>}
          </Grid>
          <Grid item xs={3}>
            <ConfigItemSelect
              required
              error={errors.stateId}
              touched={touched.stateId}
              values={values}
              handleChange={handleChange}
              label="State *"
              id="stateDropdown"
              options={stateOptions}
              fieldName="stateId"
              rootClassName={classes.stateControl}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              InputProps={{
                classes: {
                  input: classes.inputField,
                  error: classes.error
                },
                disableUnderline: true
              }}
              InputLabelProps={{
                FormLabelClasses: {
                  root: classes.labelRoot
                }
              }}
              fullWidth
              required
              error={Boolean(errors.zip) && touched.zip}
              id="zip"
              label="Zip Code"
              value={values.zip}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.zip && <FormHelperText>{errors.zip}</FormHelperText>}
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={16}>
          <Grid item xs={4}>
            <ConfigItemSelect
              required
              error={errors.regionId}
              touched={touched.regionId}
              values={values}
              handleChange={handleChange}
              label="Region"
              id="regionDropdown"
              options={regionOptions}
              fieldName="regionId"
              rootClassName={classes.regionControl}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(LocationInfo);
